import * as React from 'react';
import { RouteComponentProps, useHistory } from 'react-router';
import { Loader } from '@teamsnap/teamsnap-ui';
import * as GqlOrganization from '../../core/gql/queries/show-organizations';
import * as GqlForms from '../../core/gql/queries/get-all-forms-reg';
import { useQuery } from '@apollo/client';
import RegistrationList, { FormRetiredStatus } from '../registration/RegistrationList';
import NewFormButton from 'components/registration/NewFormButton';

type RouteParams = { orgId: string; programId: string; seasonId: string };

const SeasonRegistrationPage: React.FC<RouteComponentProps<RouteParams>> = ({
  match: {
    params: { orgId, programId, seasonId },
  },
}) => {
  const [regType, setRegType] = React.useState<'reg1' | 'reg2' | 'both'>(null);
  const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);

  const history = useHistory();

  const onClickReg2 = () => {
    history.push(`/organizations/${orgId}/registration/new`, {
      prevPath: history.location.pathname,
    });
  };

  const { loading, data } = useQuery(GqlOrganization.QUERY, {
    variables: { organizationId: +orgId },
    skip: !orgId,
    errorPolicy: 'all',
  });

  const queryForms = useQuery(GqlForms.QUERY, { variables: { organizationId: +orgId } });

  React.useEffect(() => {
    let forms = queryForms.data?.forms ?? [];

    // Filter if season level registration
    if (orgId && programId && seasonId) {
      forms = forms.filter((form) => +form.season.id === +seasonId && +form.season.program_id === +programId);
      if (forms.length > 0) {
        const isReg2 = forms[0].isReg2;
        isReg2 ? setRegType('reg2') : setRegType('reg1')
      } else {
        if (!regType && data) {
          setRegType(data.showOrganization.registrationType);
        }
      }

    }
  }, [orgId, programId, queryForms.data, seasonId, regType, data]);

  if (loading) {
    return <Loader text="Loading Season registrations..." />
  }

  return (
    <div id="programs" className="container hub-full-width">
      <div className="page-content u-xs-padXl u-flexExpandSides">
        <div className="page-content-header Grid u-flexAlignItemsCenter">
          <div className="Grid-cell u-xs-size1of2">
            <h1 data-testid="registration-page-heading">Registration</h1>
          </div>

          <NewFormButton
            orgId={+orgId}
            orgRegtype={regType}
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            onClickReg2={onClickReg2}
          />
        </div>

        <div className="page-content-body">
          <RegistrationList
            orgId={+orgId}
            seasonId={+seasonId}
            programId={+programId}
            orgName={data?.showOrganization.name}
            retiredStatus={FormRetiredStatus.Active}
          />
        </div>
      </div>
    </div>
  );
};

export default SeasonRegistrationPage;
